<div class="CouponOverlay">
  <div class="CouponOverlay-Content">
    <pf-new-coupon-code [isOverlay]="true"
                        (closeOverlay)="closeOverlay.emit($event)"></pf-new-coupon-code>
  </div>
</div>
